document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      mobileMenu.hidden = open;
      document.body.classList.toggle('menu-open', !open);
    });
  }

  document.querySelectorAll('[data-slider]').forEach(slider => {
    const slides = [...slider.querySelectorAll('[data-slide]')];
    const dots = slider.querySelector('[data-slider-dots]');
    let index = 0;
    if (slides.length < 2) return;
    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = `slider-dot${i === 0 ? ' is-active' : ''}`;
      dot.setAttribute('aria-label', `Show photo ${i + 1}`);
      dot.addEventListener('click', () => show(i));
      dots?.appendChild(dot);
    });
    const show = next => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      dots?.querySelectorAll('.slider-dot').forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };
    slider.querySelector('[data-slide-prev]')?.addEventListener('click', () => show(index - 1));
    slider.querySelector('[data-slide-next]')?.addEventListener('click', () => show(index + 1));
    window.setInterval(() => show(index + 1), 7000);
  });

  const serviceFollower = document.querySelector('[data-scroll-follow]');
  const serviceFollowTrack = document.querySelector('[data-scroll-follow-track]');
  if (serviceFollower && serviceFollowTrack) {
    let serviceFollowFrame = 0;
    const updateServiceFollower = () => {
      serviceFollowFrame = 0;
      if (window.innerWidth <= 900 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        serviceFollower.style.removeProperty('--service-follow-y');
        return;
      }

      const grid = serviceFollower.closest('.services-grid');
      if (!grid) return;
      const gridRect = grid.getBoundingClientRect();
      const maximumTravel = Math.max(0, serviceFollowTrack.offsetHeight - serviceFollower.offsetHeight);
      const animationStart = Math.min(140, window.innerHeight * 0.24);
      const animationDistance = Math.max(maximumTravel * 1.6, window.innerHeight * 0.75);
      const progress = Math.min(1, Math.max(0, (animationStart - gridRect.top) / animationDistance));
      serviceFollower.style.setProperty('--service-follow-y', `${Math.round(maximumTravel * progress)}px`);
    };
    const requestServiceFollowerUpdate = () => {
      if (serviceFollowFrame) return;
      serviceFollowFrame = window.requestAnimationFrame(updateServiceFollower);
    };
    window.addEventListener('scroll', requestServiceFollowerUpdate, { passive: true });
    window.addEventListener('resize', requestServiceFollowerUpdate);
    updateServiceFollower();
  }

  document.querySelectorAll('[data-product-thumb]').forEach(button => {
    button.addEventListener('click', () => {
      const main = document.querySelector('[data-product-main-image]');
      if (!main) return;
      main.src = button.dataset.image;
      main.srcset = '';
      document.querySelectorAll('[data-product-thumb]').forEach(item => item.classList.remove('is-active'));
      button.classList.add('is-active');
    });
  });

  document.querySelectorAll('[data-auto-submit]').forEach(control => control.addEventListener('change', () => control.form.submit()));
  const query = new URLSearchParams(window.location.search);
  document.querySelectorAll('select[name]').forEach(select => {
    const selected = query.get(select.name);
    if (selected && [...select.options].some(option => option.value === selected)) select.value = selected;
  });

  const liveCatalogGrid = document.querySelector('[data-live-catalog-grid]');
  if (liveCatalogGrid) {
    const liveCatalogCards = [...liveCatalogGrid.querySelectorAll('[data-live-catalog-card]')];
    const liveCatalogEmpty = liveCatalogGrid.querySelector('[data-live-catalog-empty]');
    const liveCategoryButtons = [...document.querySelectorAll('[data-live-catalog-filter]')];
    const liveBrandSelect = document.querySelector('[data-live-catalog-brand]');
    const liveSortSelect = document.querySelector('[data-live-catalog-sort]');
    const normalizeLiveValue = value => String(value || '').trim().toLowerCase();
    const liveCategoryFromQuery = value => {
      const term = normalizeLiveValue(value);
      if (term.includes('electronic') || term.includes('sonar')) return 'electronics';
      if (term.includes('power') || term.includes('batter')) return 'power';
      if (term.includes('trolling')) return 'trolling';
      if (term.includes('accessor') || term.includes('mount') || term.includes('deck')) return 'accessories';
      return 'all';
    };
    const validLiveSorts = new Set(['best-selling', 'price-ascending', 'price-descending', 'title-ascending', 'title-descending', 'created-descending', 'created-ascending']);
    const bestSellingRanks = new Map();
    let liveCategory = liveCategoryFromQuery(query.get('filter.p.product_type'));
    let liveBrand = query.get('filter.p.vendor') || '';
    let liveSort = validLiveSorts.has(query.get('sort_by')) ? query.get('sort_by') : 'best-selling';

    if (liveBrandSelect && [...liveBrandSelect.options].some(option => normalizeLiveValue(option.value) === normalizeLiveValue(liveBrand))) {
      const matchingBrand = [...liveBrandSelect.options].find(option => normalizeLiveValue(option.value) === normalizeLiveValue(liveBrand));
      liveBrandSelect.value = matchingBrand.value;
      liveBrand = matchingBrand.value;
    } else {
      liveBrand = '';
      if (liveBrandSelect) liveBrandSelect.value = '';
    }
    if (liveSortSelect) liveSortSelect.value = liveSort;

    const syncLiveCatalogUrl = () => {
      const next = new URL(window.location.href);
      const categoryLabels = { electronics: 'Marine Electronics', power: 'Batteries + Power', trolling: 'Trolling Motors', accessories: 'Accessories' };
      if (liveCategory === 'all') next.searchParams.delete('filter.p.product_type');
      else next.searchParams.set('filter.p.product_type', categoryLabels[liveCategory]);
      if (liveBrand) next.searchParams.set('filter.p.vendor', liveBrand);
      else next.searchParams.delete('filter.p.vendor');
      next.searchParams.set('sort_by', liveSort);
      window.history.replaceState({}, '', next);
    };

    const renderLiveCatalog = () => {
      liveCategoryButtons.forEach(button => button.classList.toggle('is-active', button.dataset.liveCatalogFilter === liveCategory));
      const sortedCards = [...liveCatalogCards].sort((a, b) => {
        if (liveSort === 'price-ascending') return Number(a.dataset.liveCatalogPrice) - Number(b.dataset.liveCatalogPrice);
        if (liveSort === 'price-descending') return Number(b.dataset.liveCatalogPrice) - Number(a.dataset.liveCatalogPrice);
        if (liveSort === 'title-ascending') return a.dataset.liveCatalogTitle.localeCompare(b.dataset.liveCatalogTitle);
        if (liveSort === 'title-descending') return b.dataset.liveCatalogTitle.localeCompare(a.dataset.liveCatalogTitle);
        if (liveSort === 'created-descending') return Number(b.dataset.liveCatalogPublished) - Number(a.dataset.liveCatalogPublished);
        if (liveSort === 'created-ascending') return Number(a.dataset.liveCatalogPublished) - Number(b.dataset.liveCatalogPublished);
        return (bestSellingRanks.get(a.dataset.liveCatalogHandle) ?? Number(a.dataset.liveCatalogRank)) - (bestSellingRanks.get(b.dataset.liveCatalogHandle) ?? Number(b.dataset.liveCatalogRank));
      });
      sortedCards.forEach(card => liveCatalogGrid.insertBefore(card, liveCatalogEmpty));

      let visibleProducts = 0;
      sortedCards.forEach(card => {
        const categoryMatches = liveCategory === 'all' || card.dataset.liveCatalogCategory === liveCategory;
        const brandMatches = !liveBrand || normalizeLiveValue(card.dataset.liveCatalogVendor) === normalizeLiveValue(liveBrand);
        card.hidden = !(categoryMatches && brandMatches);
        if (!card.hidden) visibleProducts += 1;
      });
      if (liveCatalogEmpty) liveCatalogEmpty.hidden = visibleProducts !== 0;
      syncLiveCatalogUrl();
    };

    liveCategoryButtons.forEach(button => button.addEventListener('click', () => {
      liveCategory = button.dataset.liveCatalogFilter || 'all';
      renderLiveCatalog();
    }));
    liveBrandSelect?.addEventListener('change', () => {
      liveBrand = liveBrandSelect.value;
      renderLiveCatalog();
    });
    liveSortSelect?.addEventListener('change', () => {
      liveSort = liveSortSelect.value;
      renderLiveCatalog();
    });

    renderLiveCatalog();

    const bestSellingUrl = new URL(window.location.href);
    bestSellingUrl.search = '';
    bestSellingUrl.searchParams.set('sort_by', 'best-selling');
    fetch(bestSellingUrl)
      .then(response => response.ok ? response.text() : Promise.reject(new Error('Unable to load best-selling order')))
      .then(html => {
        const documentCopy = new DOMParser().parseFromString(html, 'text/html');
        [...documentCopy.querySelectorAll('[data-live-catalog-card]')].forEach((card, index) => {
          bestSellingRanks.set(card.dataset.liveCatalogHandle, index);
        });
        if (liveSort === 'best-selling') renderLiveCatalog();
      })
      .catch(() => {});
  }

  const catalogGrid = document.querySelector('[data-catalog-grid]');
  if (catalogGrid) {
    const cards = [...catalogGrid.querySelectorAll('[data-catalog-card]')];
    const categoryButtons = [...document.querySelectorAll('[data-catalog-filter]')];
    const brandSelect = document.querySelector('[data-catalog-brand]');
    const sortSelect = document.querySelector('[data-catalog-sort]');
    const emptyState = document.querySelector('[data-catalog-empty]');
    const productView = document.querySelector('[data-catalog-product-view]');
    const shopSection = document.querySelector('[data-catalog-shop]');
    const pageHero = document.querySelector('[data-catalog-page-hero]');
    const normalize = value => String(value || '').trim().toLowerCase();
    const categoryFromQuery = value => {
      const term = normalize(value);
      if (term.includes('electronic') || term.includes('sonar')) return 'electronics';
      if (term.includes('power') || term.includes('batter')) return 'power';
      if (term.includes('trolling')) return 'trolling';
      if (term.includes('accessor') || term.includes('mount') || term.includes('deck')) return 'accessories';
      return 'all';
    };

    const productHandle = query.get('product');
    let category = categoryFromQuery(query.get('filter.p.product_type'));
    let brand = query.get('filter.p.vendor') || '';
    let sort = query.get('sort_by') || 'best-selling';

    if (brandSelect && [...brandSelect.options].some(option => normalize(option.value) === normalize(brand))) {
      brandSelect.value = [...brandSelect.options].find(option => normalize(option.value) === normalize(brand)).value;
      brand = brandSelect.value;
    }
    if (sortSelect && [...sortSelect.options].some(option => option.value === sort)) sortSelect.value = sort;

    const syncUrl = () => {
      const next = new URL(window.location.href);
      if (category === 'all') next.searchParams.delete('filter.p.product_type');
      else {
        const labels = { electronics: 'Marine Electronics', power: 'Batteries + Power', trolling: 'Trolling Motors', accessories: 'Accessories' };
        next.searchParams.set('filter.p.product_type', labels[category]);
      }
      if (brand) next.searchParams.set('filter.p.vendor', brand);
      else next.searchParams.delete('filter.p.vendor');
      if (sort && sort !== 'best-selling') next.searchParams.set('sort_by', sort);
      else next.searchParams.delete('sort_by');
      window.history.replaceState({}, '', next);
    };

    const renderCatalog = () => {
      categoryButtons.forEach(button => button.classList.toggle('is-active', button.dataset.catalogFilter === category));
      const sorted = [...cards].sort((a, b) => {
        if (sort === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
        if (sort === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
        if (sort === 'title-asc') return a.dataset.title.localeCompare(b.dataset.title);
        return Number(a.dataset.rank) - Number(b.dataset.rank);
      });
      sorted.forEach(card => catalogGrid.appendChild(card));
      let visible = 0;
      cards.forEach(card => {
        const categoryMatch = category === 'all' || card.dataset.category === category;
        const brandMatch = !brand || normalize(card.dataset.brand) === normalize(brand);
        card.hidden = !(categoryMatch && brandMatch);
        if (!card.hidden) visible += 1;
      });
      if (emptyState) emptyState.hidden = visible !== 0;
      syncUrl();
    };

    const renderProductView = () => {
      if (!productHandle || !productView) return false;
      const card = cards.find(item => item.dataset.productHandle === productHandle);
      if (!card) return false;
      const image = card.querySelector('.product-visual img');
      const categoryLabel = card.querySelector('.category')?.textContent.trim() || card.dataset.brand;
      const pricePrefix = /helm pad|terrova|powerdrive/i.test(card.dataset.title) ? 'From ' : '';
      const descriptions = {
        electronics: 'Purpose-built marine electronics for clearer information, reliable networking, and confident days on the water.',
        power: 'Dependable marine power selected for long run time, clean installation, and reliable performance on the water.',
        trolling: 'Boat control built for precise positioning, dependable operation, and easier fishing throughout the day.',
        accessories: 'A practical marine upgrade selected to improve organization, protection, and everyday use on the boat.'
      };
      const features = {
        electronics: ['Marine-ready construction', 'Professional installation available', 'Setup and configuration support'],
        power: ['Built for marine use', 'Charging and rigging support available', 'Professional installation available'],
        trolling: ['Freshwater-ready performance', 'Rigging and setup support available', 'Professional installation available'],
        accessories: ['Selected for marine use', 'Fit and application support available', 'Professional installation available']
      };
      productView.querySelector('[data-catalog-detail-title]').textContent = card.dataset.title;
      productView.querySelector('[data-catalog-detail-heading]').textContent = card.dataset.title;
      productView.querySelector('[data-catalog-detail-brand]').textContent = categoryLabel;
      productView.querySelector('[data-catalog-detail-price]').textContent = `${pricePrefix}$${Number(card.dataset.price).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
      productView.querySelector('[data-catalog-detail-description]').textContent = descriptions[card.dataset.category] || descriptions.accessories;
      const detailImage = productView.querySelector('[data-catalog-detail-image]');
      detailImage.src = image.currentSrc || image.src;
      detailImage.alt = card.dataset.title;
      productView.querySelector('[data-catalog-detail-features]').innerHTML = (features[card.dataset.category] || features.accessories).map(feature => `<li>${feature}</li>`).join('');
      const orderLink = productView.querySelector('[data-catalog-detail-order]');
      const orderUrl = new URL(orderLink.href);
      orderUrl.searchParams.set('product', card.dataset.title);
      orderUrl.hash = 'quote';
      orderLink.href = orderUrl.toString();
      const installLink = productView.querySelector('[data-catalog-detail-install]');
      const installUrl = new URL(installLink.href);
      installUrl.searchParams.set('topic', 'Product Installation');
      installUrl.searchParams.set('product', card.dataset.title);
      installUrl.hash = 'quote';
      installLink.href = installUrl.toString();
      const relatedGrid = productView.querySelector('[data-catalog-related-grid]');
      const related = cards.filter(item => item !== card && item.dataset.category === card.dataset.category).slice(0, 3);
      relatedGrid.replaceChildren(...related.map(item => item.cloneNode(true)));
      productView.hidden = false;
      if (shopSection) shopSection.hidden = true;
      if (pageHero) pageHero.hidden = true;
      document.title = `${card.dataset.title} | BlueWater`;
      return true;
    };

    categoryButtons.forEach(button => button.addEventListener('click', () => {
      category = button.dataset.catalogFilter || 'all';
      renderCatalog();
    }));
    brandSelect?.addEventListener('change', () => {
      brand = brandSelect.value;
      renderCatalog();
    });
    sortSelect?.addEventListener('change', () => {
      sort = sortSelect.value;
      renderCatalog();
    });
    if (!renderProductView()) renderCatalog();
  }

  const jumpLinks = [...document.querySelectorAll('[data-design-jump] a')];
  const optionSections = [...document.querySelectorAll('.option-section[id]')];
  if (jumpLinks.length && optionSections.length && 'IntersectionObserver' in window) {
    const setActiveJump = id => jumpLinks.forEach(link => {
      const active = link.hash === `#${id}`;
      link.classList.toggle('is-active', active);
      if (active) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        setActiveJump(entry.target.id);
      });
    }, { rootMargin: '-25% 0px -60% 0px' });
    jumpLinks.forEach(link => link.addEventListener('click', () => setActiveJump(link.hash.slice(1))));
    optionSections.forEach(section => observer.observe(section));
    setActiveJump((window.location.hash || `#${optionSections[0].id}`).slice(1));
  }

  document.querySelectorAll('.adaptive-quote').forEach(form => {
    const quoteSuccess = form.querySelector('[data-quote-success]');
    if (quoteSuccess) {
      window.requestAnimationFrame(() => {
        quoteSuccess.focus({ preventScroll: true });
        quoteSuccess.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'center'
        });
      });
      return;
    }

    const projectInputs = [...form.querySelectorAll('[data-project-type]')];
    const projectPanels = [...form.querySelectorAll('[data-project-panel]')];
    const checkboxInputs = [...form.querySelectorAll('[data-checkbox-group]')];
    const checkboxSummaries = [...form.querySelectorAll('[data-checkbox-summary]')];
    const phoneInput = form.querySelector('[data-phone-input]');
    const boatYearInput = form.querySelector('[data-boat-year]');
    const digitOnlyInputs = [...form.querySelectorAll('[data-digits-only]')];
    const placeholder = form.querySelector('[data-conditional-placeholder]');
    const error = form.querySelector('[data-project-type-error]');
    const formatPhone = () => {
      if (!phoneInput) return;
      const digits = phoneInput.value.replace(/\D/g, '').slice(0, 10);
      if (digits.length < 4) phoneInput.value = digits;
      else if (digits.length < 7) phoneInput.value = `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
      else phoneInput.value = `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
      phoneInput.setCustomValidity(digits.length && digits.length !== 10 ? 'Enter a 10-digit phone number.' : '');
    };
    const validateBoatYear = () => {
      if (!boatYearInput) return;
      boatYearInput.value = boatYearInput.value.replace(/\D/g, '').slice(0, 4);
      const year = Number(boatYearInput.value);
      const maximumYear = new Date().getFullYear() + 1;
      const invalid = boatYearInput.value.length === 4 && (year < 1900 || year > maximumYear);
      boatYearInput.setCustomValidity(invalid ? `Enter a boat year between 1900 and ${maximumYear}.` : '');
    };
    digitOnlyInputs.forEach(input => input.addEventListener('input', () => {
      input.value = input.value.replace(/\D/g, '').slice(0, Number(input.maxLength) || undefined);
    }));
    phoneInput?.addEventListener('input', formatPhone);
    boatYearInput?.addEventListener('input', validateBoatYear);
    const syncCheckboxSummaries = () => {
      checkboxSummaries.forEach(summary => {
        summary.value = checkboxInputs
          .filter(input => input.dataset.checkboxGroup === summary.dataset.checkboxSummary && input.checked && !input.disabled)
          .map(input => input.value)
          .join(', ');
      });
    };
    const syncProjectFields = () => {
      const selected = new Set(projectInputs.filter(input => input.checked).map(input => input.dataset.projectType));
      projectPanels.forEach(panel => {
        const matchingTypes = panel.dataset.projectPanel.split(' ');
        const hidden = !matchingTypes.some(type => selected.has(type));
        panel.hidden = hidden;
        panel.querySelectorAll('input, select, textarea').forEach(control => { control.disabled = hidden; });
      });
      if (placeholder) placeholder.hidden = selected.size > 0;
      if (projectInputs[0]) projectInputs[0].setCustomValidity(selected.size ? '' : 'Choose at least one project type.');
      if (error && selected.size) error.textContent = '';
      syncCheckboxSummaries();
    };
    const selectProjectType = type => {
      const input = projectInputs.find(option => option.dataset.projectType === type);
      if (input) input.checked = true;
    };
    const requestedService = query.get('service');
    const serviceMap = {
      'Custom SeaDek': ['seadek'],
      'Electronics + Rigging': ['electronics', 'rigging'],
      'Power + Trolling Motors': ['power', 'trolling'],
      'Product Installation': ['equipment'],
      'Fitment Help': ['equipment'],
      'Equipment + Installation': ['equipment'],
      'Audio + Accessories': ['accessories'],
      'Boat Care + Fish House': ['seasonal'],
      'Seasonal Care + Storage': ['seasonal']
    };
    if (requestedService) {
      const exactMatch = projectInputs.find(input => input.value === requestedService);
      if (exactMatch) exactMatch.checked = true;
      (serviceMap[requestedService] || []).forEach(selectProjectType);
    }
    if (/fitment|installation/i.test(query.get('topic') || '')) selectProjectType('equipment');
    projectInputs.forEach(input => input.addEventListener('change', syncProjectFields));
    checkboxInputs.forEach(input => input.addEventListener('change', syncCheckboxSummaries));
    form.addEventListener('submit', () => {
      syncProjectFields();
      if (!projectInputs.some(input => input.checked) && error) error.textContent = 'Choose at least one project type.';
    });
    syncProjectFields();
  });

  document.querySelectorAll('[data-accordion-button]').forEach(button => {
    button.addEventListener('click', () => {
      const item = button.closest('.accordion-item');
      const opening = !item.classList.contains('is-open');
      item.parentElement.querySelectorAll('.accordion-item').forEach(sibling => {
        sibling.classList.remove('is-open');
        sibling.querySelector('[data-accordion-button]')?.setAttribute('aria-expanded', 'false');
      });
      item.classList.toggle('is-open', opening);
      button.setAttribute('aria-expanded', String(opening));
    });
  });

  const allGalleryItems = [...document.querySelectorAll('[data-lightbox]')];
  const visibleGalleryItems = allGalleryItems.filter(item => !item.hasAttribute('data-lightbox-hidden'));
  const lightbox = document.querySelector('[data-lightbox-modal]');
  let galleryItems = visibleGalleryItems;
  let lightboxIndex = 0;
  const showLightbox = index => {
    if (!galleryItems.length || !lightbox) return;
    lightboxIndex = (index + galleryItems.length) % galleryItems.length;
    const item = galleryItems[lightboxIndex];
    const source = item.matches('img') ? item : item.querySelector('img');
    if (!source) return;
    const image = lightbox.querySelector('[data-lightbox-image]');
    image.src = source.currentSrc || source.src;
    image.alt = source.alt;
    lightbox.querySelector('[data-lightbox-caption]').textContent = source.alt;
    lightbox.hidden = false;
    document.body.classList.add('lightbox-open');
    lightbox.querySelector('[data-lightbox-close]')?.focus();
  };
  const closeLightbox = () => {
    if (lightbox) lightbox.hidden = true;
    document.body.classList.remove('lightbox-open');
  };
  const openLightbox = item => {
    const group = item.dataset.lightboxGroup;
    galleryItems = group
      ? allGalleryItems.filter(candidate => candidate.dataset.lightboxGroup === group)
      : visibleGalleryItems;
    showLightbox(galleryItems.indexOf(item));
  };
  visibleGalleryItems.forEach(item => {
    const source = item.matches('img') ? item : item.querySelector('img');
    const group = item.dataset.lightboxGroup;
    const groupSize = group
      ? allGalleryItems.filter(candidate => candidate.dataset.lightboxGroup === group).length
      : 1;
    item.tabIndex = 0;
    item.setAttribute('role', 'button');
    item.setAttribute('aria-label', groupSize > 1
      ? `Open ${groupSize}-image gallery: ${source?.alt || 'project images'}`
      : `Open image: ${source?.alt || 'project image'}`);
    item.addEventListener('click', () => openLightbox(item));
    item.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openLightbox(item);
      }
    });
  });
  lightbox?.querySelector('[data-lightbox-close]')?.addEventListener('click', closeLightbox);
  lightbox?.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => showLightbox(lightboxIndex - 1));
  lightbox?.querySelector('[data-lightbox-next]')?.addEventListener('click', () => showLightbox(lightboxIndex + 1));
  lightbox?.addEventListener('click', event => { if (event.target === lightbox) closeLightbox(); });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closeLightbox();
    if (!lightbox?.hidden && event.key === 'ArrowLeft') showLightbox(lightboxIndex - 1);
    if (!lightbox?.hidden && event.key === 'ArrowRight') showLightbox(lightboxIndex + 1);
  });
});
